import { WONDERSCHOOL_FAVICON } from 'main/ui'

export enum Size {
  SMALL = 16,
  LARGE = 32,
}

export interface IAttributes {
  href: string
  rel: string
  sizes: string
  type: string
}

export function attributes(size: Size, src: string | undefined): IAttributes {
  const params: string = `-/resize/${size}x/`

  let href: string = src || WONDERSCHOOL_FAVICON
  href = `${href}${params}`

  return { href, rel: 'icon', sizes: `${size}x${size}`, type: 'image/png' }
}
